import { StorageType } from 'mbs-ui-shared';

export const StorageFormName = {
  [StorageType.AmazonS3]: 'amazonS3',
  [StorageType.AmazonS3Eu]: 'amazonS3',
  [StorageType.AmazonS3Chinese]: 'amazonS3',
  [StorageType.BackblazeB2]: 'b2',
  [StorageType.LocalFS]: 'localFS',
  [StorageType.FTP]: 'ftp',
  [StorageType.SFTP]: 'sftp',
  [StorageType.GoogleCloud]: 'googleCloud',
  [StorageType.Google]: 'googleCloud',
  [StorageType.Azure]: 'azure',
  [StorageType.AzureVM]: 'azureVm',
  [StorageType.Minio]: 'minio',
  [StorageType.S3Compatible]: 's3Compatible',
  [StorageType.Wasabi]: 'wasabi',
  [StorageType.ScalityCloud]: 'scality',
  [StorageType.IDriveE2]: 'iDrive',
  [StorageType.GoogleDriveOAuth]: 'googleDrive',
  [StorageType.GoogleDrive]: 'googleDrive',
  [StorageType.OpenStack]: 'openStack',
  [StorageType.ImpossibleCloud]: 'impossibleCloud'
};

export const fakeSecretKey = '9514b171-53a9-45f9-98ce-69ce9e53b176';

export const e2eLocators = {
  accountName: 'account-name-ctrl',
  sharedKey: 'shared-key-ctrl',
  accountType: 'account-type-ctrl',
  endpoint: 'endpoint-ctrl',
  endpointReadonly: 'endpoint-readonly-block',
  logIn: 'log-in-btn',
  subscriptionDisplayName: 'subscription-name-ctrl',
  tenantId: 'tenant-id-block',
  accountId: 'account-id-ctrl',
  applicationKey: 'application-key-ctrl',
  useCredentials: 'use-credentials-ctrl',
  user: 'user-ctrl',
  password: 'password-ctrl',
  isPrivateStorage: 'is-private-storage-ctrl',
  useSSL: 'use-ssl-ctrl',
  keepAlive: 'keep-alive-ctrl',
  usePassiveMode: 'use-passive-mode-ctrl',
  accessKey: 'access-key-ctrl',
  secretKey: 'secret-key-ctrl',
  storageType: 'storage-type-ctrl',
  authType: 'auth-type-ctrl',
  minimumRequiredPermissionsBtn: 'minimum-required-permissions-btn',
  arnRole: 'arn-role-ctrl',
  isGov: 'is-gov-ctrl',
  serviceAccountEmail: 'service-account-email-ctrl',
  files: 'files-control',
  projectId: 'project-id-ctrl',
  revokeAccess: 'revoke-access-btn',
  apiKey: 'api-key-ctrl',
  keystoneVersion: 'keystone-version-ctrl',
  domainIdentifier: 'domain-identifier-ctrl',
  domainName: 'domain-name-ctrl',
  domainId: 'domain-id-ctrl',
  useScope: 'use-scope-ctrl',
  projectIdentifier: 'project-identifier-ctrl',
  projectName: 'project-name-ctrl',
  tenantIdentifier: 'tenant-identifier-ctrl',
  tenantName: 'tenant-name-ctrl',
  tenantIdCtrl: 'tenant-id-ctrl',
  privateStorage: 'private-storage-ctrl',
  useInternalUrls: 'use-internal-urls-ctrl',
  ignoreCertificates: 'ignore-certificates-ctrl',
  http: 'http-ctrl',
  https: 'https-ctrl',
  ignoreCertificate: 'ignore-certificate-ctrl',
  isVersioningEnabled: 'is-versioning-enabled-ctrl',
  keepCredentialsOnEndpoint: 'keep-credentials-on-endpoint-ctrl',
  isSyntheticBackupAllowed: 'is-synthetic-backup-allowed-ctrl',
  useNativeMultipartUpload: 'use-native-multipart-upload-ctrl',
  useSignatureVersion4: 'use-signature-version-4-ctrl',
  useSignatureVersion2: 'use-signature-version-2-ctrl',
  useVHostRequestStyleFalse: 'use-v-host-request-style-false',
  useVHostRequestStyleTrue: 'use-v-host-request-style-true'
};
